export default {
  name: "WineStockListModalStockActionButton",
  props: {
    item: {
      type: Object
    },
    isChangingUsedStock: {
      type: Boolean
    },
    wineStockStatus: {
      type: Object
    },
    isBasket: {
      type: Boolean
    },
    isLoading: {
      type: Boolean
    },
    isAddToCartDisabled: {
      type: Boolean
    }
  }
};